
import BrasselerColors from "@BUSAMedicalMarketing/Utils/Colors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import SearchInput from "@insite/content-library/Widgets/Header/SearchInput";
import Link from "@insite/mobius/Link";
import * as React from "react";
import styled, { css } from "styled-components";

interface LinkItem {
    title: string;
    url?: string;
    children?: LinkItem[];
}

interface Props {
    links: LinkItem[];
    isOpen: boolean;
    toggleDrawer?: () => void;
}

const Drawer = styled.div<{ isOpen: boolean }>`
    position: fixed;
    top: 80px;
    left: 50%;
    transform: translate(-50%, ${p => (p.isOpen ? "0%" : "-120%")});

    width: 80%;
    background: white;

    z-index: 9999;
    visibility: ${({ isOpen }) => (isOpen ? "visible" : "hidden")};
    pointer-events: ${({ isOpen }) => (isOpen ? "auto" : "none")};
    opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};

    transition:
        transform 0.5s ease,
        opacity 0.3s ease,
        visibility 0.3s;
`;

const MenuRow = styled.div<{ hasChildren?: boolean }>`
    padding: 14px 18px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    color: ${BrasselerColors.pgray10} !important ;
    font-weight: ${({ hasChildren }) => (hasChildren ? 600 : 400)};
`;

const ChildWrapper = styled.div`
    padding-left: 18px;
    background: #fafafa;
`;

const Arrow = styled.span`
    font-size: 14px;
`;

const MenuItem: React.FC<{ link: LinkItem; toggleDrawer?: () => void }> = ({ link, toggleDrawer }) => {
    const [open, setOpen] = React.useState(false);

    const hasChildren = link.children && link.children.length > 0;

    const toggle = () => {
        if (hasChildren) {
            setOpen(!open);
        }
    };

    return (
        <>
            <MenuRow onClick={toggle} hasChildren={hasChildren}>
                {link.url ? <Link href={link.url} onClick={()=>{setOpen(false); toggleDrawer?.();}}>{link.title}</Link> : link.title}
                {hasChildren && (
                    <Arrow>
                        <svg
                            focusable="false"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                    </Arrow>
                )}
            </MenuRow>

            {hasChildren && open && (
                <ChildWrapper>
                    {link.children!.map((child, i) => (
                        <MenuItem key={i} link={child} />
                    ))}
                </ChildWrapper>
            )}
        </>
    );
};

const CustomMobileDrawer: React.FC<Props> = ({ links, isOpen, toggleDrawer }) => {
    return (
        <Drawer isOpen={isOpen}>
            {links.map((link, i) => (
                <MenuItem key={i} link={link} toggleDrawer={toggleDrawer} />
            ))}
            <StyledWrapper style={{display: "flex", justifyContent: "center",alignItems:"center"}}>
                <SearchInput id="" extendedStyles={{popoverWrapper:{css:css`justify-content: center; margin-top: 10px;`}}}/>
            </StyledWrapper>
        </Drawer>
    );
};

export default CustomMobileDrawer;
